import _classCallCheck from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

import { UpploadService } from "../service";
import { safeListen } from "../helpers/elements";
import { translate } from "../helpers/i18n";

var Local = /*#__PURE__*/function (_UpploadService) {
  _inherits(Local, _UpploadService);

  var _super = _createSuper(Local);

  function Local() {
    var _this;

    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        mimeTypes = _ref.mimeTypes,
        maxFileSize = _ref.maxFileSize;

    _classCallCheck(this, Local);

    _this = _super.call(this);
    _this.name = "local";
    _this.icon = "<svg aria-hidden=\"true\" viewBox=\"0 0 256 256\" xmlns=\"http://www.w3.org/2000/svg\"><g fill=\"#000\" fill-rule=\"nonzero\"><path d=\"M177 56L125 4l-3-2v57h57c0-2-1-3-2-3z\"/><path d=\"M173 113h8V75h-66c-5 0-8-4-8-8V1H27c-4 0-8 4-8 8v184c0 4 4 8 8 8h65v-8c0-45 36-80 81-80z\"/><path d=\"M173 128c-36 0-65 29-65 64s29 64 65 64c35 0 64-29 64-64s-29-64-64-64zm27 63h-14v33c0 2-2 3-4 3h-20c-2 0-3-1-3-3v-33h-14c-3 0-5-3-3-5l28-30c1-2 3-2 5 0l27 30c2 2 1 5-2 5z\"/></g></svg>";
    _this.color = "#34495e";
    _this.mimeTypes = ["image/gif", "image/jpeg", "image/jpg", "image/png"];
    _this.maxFileSize = Infinity;

    _this.template = function (params) {
      return "<div class=\"drop-area\">\n      <div>".concat(params.translate("services.local.drop"), "</div>\n      <em>").concat(params.translate("services.local.or"), "</em>\n      <button class=\"uppload-button uppload-button--cta\" style=\"background: ").concat(_this.color, "\">").concat(params.translate("services.local.button"), "</button>\n    </div>\n      <div class=\"alternate-input\">\n        <input type=\"file\" accept=\"").concat(_this.mimeTypes.join(), "\"").concat(params.uppload.settings.multiple ? " multiple" : "", "></div><button class=\"need-help-link\"><span>").concat(translate("needHelp"), "</span aria-hidden=\"true\"><span>?</span></button>");
    };

    _this.handlers = function (params) {
      var dropArea = params.uppload.container.querySelector(".drop-area");

      if (dropArea) {
        safeListen(dropArea, "drop", function (event) {
          return _this.dropHandler(params, event);
        });
        safeListen(dropArea, "dragover", function (event) {
          return _this.dragHandler(params, event);
        });
        safeListen(dropArea, "dragend", function (event) {
          return _this.dragStop(params, event);
        });
        safeListen(dropArea, "dragexit", function (event) {
          return _this.dragStop(params, event);
        });
        safeListen(dropArea, "dragleave", function (event) {
          return _this.dragStop(params, event);
        });
        safeListen(dropArea, "click", function (event) {
          return _this.fileSelect(params, event);
        });
      }

      var input = params.uppload.container.querySelector(".alternate-input input[type=file]");
      if (input) safeListen(input, "change", function (event) {
        return _this.getFile(params, event);
      });
      var helpButton = params.uppload.container.querySelector(".need-help-link");
      if (helpButton) safeListen(helpButton, "click", function () {
        return params.showHelp("/services/local");
      });
    };

    if (mimeTypes) _this.mimeTypes = mimeTypes;
    if (maxFileSize) _this.maxFileSize = maxFileSize;
    return _this;
  }

  _createClass(Local, [{
    key: "getFile",
    value: function getFile(params, event) {
      event.preventDefault();
      var files = event.target.files;
      var file = null;

      if (files) {
        if (params.uppload.settings.multiple && files.length > 1) return params.uploadMultiple(Array.from(files));

        for (var i = 0; i < files.length; i++) {
          var item = files[i];
          if (this.mimeTypes.indexOf(item.type) !== -1) if (item.size < this.maxFileSize) file = item;else params.handle(new Error(params.translate("errors.file_too_large", "".concat(this.maxFileSize, " bytes"))));
        }
      }

      if (!file) return;
      if (file) params.next({
        blob: file,
        size: file.size,
        type: file.type,
        lastModified: file.lastModified ? new Date(file.lastModified) : undefined,
        name: file.name
      });
    }
  }, {
    key: "fileSelect",
    value: function fileSelect(params, event) {
      var input = params.uppload.container.querySelector(".alternate-input input[type=file]");
      if (input) input.click();
    }
  }, {
    key: "dragStop",
    value: function dragStop(params, event) {
      var dropArea = params.uppload.container.querySelector(".drop-area");
      if (dropArea) dropArea.classList.remove("drop-area-active");
    }
  }, {
    key: "dragHandler",
    value: function dragHandler(params, event) {
      event.preventDefault();
      var dropArea = params.uppload.container.querySelector(".drop-area");
      if (dropArea) dropArea.classList.add("drop-area-active");
    }
  }, {
    key: "dropHandler",
    value: function dropHandler(params, event) {
      event.preventDefault();
      this.dragStop(params, event);
      var file = null; // getAsFile() returns File | null

      if (event.dataTransfer && event.dataTransfer.items) {
        for (var i = 0; i < event.dataTransfer.items.length; i++) {
          var item = event.dataTransfer.items[i];

          if (item.kind === "file" && this.mimeTypes.indexOf(item.type) !== -1) {
            file = item.getAsFile();

            if (!file || file.size > this.maxFileSize) {
              file = null;
              params.handle(new Error(params.translate("errors.file_too_large", "".concat(this.maxFileSize, " bytes"))));
            }
          }
        }
      }

      if (!file) return;
      if (file) params.next({
        blob: file,
        size: file.size,
        type: file.type,
        lastModified: file.lastModified ? new Date(file.lastModified) : undefined,
        name: file.name
      });
    }
  }]);

  return Local;
}(UpploadService);

export { Local as default };